import { formFieldsConfigProcessed } from "./config/AdditionalInformationConfig";
import { formFieldsState } from "./state/AdditionalInformationState";
import { formFieldsValidation } from "./validations/AdditionalInformationValidations";
import { ADDITIONAL_INFORMATION_CONSTANTS } from "../../constants";

export const formName = ADDITIONAL_INFORMATION_CONSTANTS.FORM_NAME;
export const formState = formFieldsState;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;

export { formFieldsConfigProcessed, formFieldsState, formFieldsValidation };